<div class="!mt-[24px] min-[991px]:!mt-[52px] mb-[24px] min-[991px]:mb-[48px]">
  <h2 class="min-[991px]:mb-[16px] mb-[3px] text-[16px] min-[991px]:text-[32px] text-[#000] font-[500]">
    {{ titleKey | translate }}
  </h2>
  <p *ngIf="descriptionKey" class="text-[10px] min-[991px]:text-[20px] text-[#979797] font-[400]">
    {{ descriptionKey | translate }}
  </p>
</div>

<form
  class="sign-up-form add-employees-form"
  fxLayout="column"
  fxLayoutAlign="start stretch"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="field-group add-box" fxLayout="column" fxLayoutAlign="start stretch">
    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-between start"
      fxLayoutGap="16px"
      class="inputs-row"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxFlex.gt-sm="48"
        fxFlex.lt-md="100"
      >
        <mat-label class="mb-[2px] min-[991px]:mb-[8px] text-[#000] text-[12px] min-[991px]:text-[20px] font-[400] min-[991px]:font-[500]">
          {{ 'EmployeeName' | translate }}
        </mat-label>
        <mat-form-field appearance="outline">
          <input
            matInput
            [(ngModel)]="employeeName"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="'ENTER_EMPLOYEE_NAME' | translate"
          />
        </mat-form-field>
      </div>

      <!-- <div
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxFlex.gt-sm="48"
        fxFlex.lt-md="100"
      >
        <mat-label class="label">
          {{ 'Role' | translate }}
        </mat-label>
        <mat-form-field appearance="outline">
          <mat-select
            disableRipple
            formControlName="PositionId"
            [placeholder]="'Role' | translate"
          >
            <mat-option
              *ngFor="let position of positions"
              [value]="position.PositionId"
            >
              {{ dir == 'rtl' ? position.NameAr : position.NameEn }}
            </mat-option>
          </mat-select>
          <mat-error>
            <app-error-form
              [name]="'Role' | translate"
              [control]="form.controls['PositionId']"
            ></app-error-form>
          </mat-error>
        </mat-form-field>
      </div> -->
    </div>

    <div
      class="add-button-row"
      fxLayout="row"
      fxLayoutAlign="end center"
    >
      <button
        type="button"
        class="add-btn"
        (click)="onAddEmployee()"
        [disabled]="!employeeName"
      >
        {{ 'Add' | translate }}
      </button>
    </div>
  </div>

  <div
    class="field-group employees-chips"
    *ngIf="employeeList.length"
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayoutGap="12px"
    fxLayoutWrap
  >
    <div
      *ngFor="let employee of employeeList"
      class="employee-chip"
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px"
    >
      <button
        type="button"
        class="chip-remove-btn"
        (click)="onRemovedEmployee(employee)"
        aria-label="Remove employee"
      >
        ×
      </button>
      <div class="chip-text" fxLayout="column" fxLayoutAlign="start start">
        <span class="employee-name">{{ employee }}</span>
        <!-- <span class="employee-role" *ngIf="form.get('PositionId')?.value">
          {{ employeeRole }}
        </span> -->
      </div>
    </div>
  </div>

  <div
    class="actions-buttons"
    *ngIf="showActions"
    fxLayout="row"
    fxLayoutAlign="stretch center"
  >
    <button
      type="button"
      class="action-btn prev-btn"
      fxFlex="1 1 0"
      (click)="onCancelClick()"
    >
      {{ cancelLabelKey | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="action-btn submit-btn"
      fxFlex="1 1 0"
      type="submit"
      [disabled]="!canConfirm || loading"
    >
      {{ submitLabelKey | translate }}
      <span class="btn-spinner-icon" *ngIf="loading"></span>
    </button>
  </div>
</form>

